/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
*/
import {Dic} from '$utils'
import {Validate} from '$utils'
import i18n from '@src/common/lib/i18n'

const checkControlName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('personCm.placeholder.name')));
  }
  if (value.length < 1 || value.length > 50) {
    return callback(new Error(i18n.t('personCm.message.length')));
  }
  if (!Validate.validateNames(value)) {
    return callback(new Error(i18n.t('personCm.message.value')))
  }
  callback();
};

export const optionForm =() =>{
    return[
         {
           label: i18n.t('personCm.label.name'),
           prop: 'name',
           span: 24,
           clearable: true,
           rules: [
            { required: true, message: i18n.t('personCm.placeholder.name'), trigger: 'blur' },
            {validator: checkControlName, trigger: 'blur'}
           ],
           placeholder: i18n.t('personCm.placeholder.name'),
         },
         {
           label: i18n.t('personCm.label.threshold'),
           prop: 'confidenceThreshold',
           max: 100,
           span: 24,
           min: 1,
           type: 'silder',
           rules: [{ required: true }]
         },
         {
           label: i18n.t('personCm.label.type'),
           prop: 'type',
           span: 24,
           type: 'radio',
           formslot: true,
           dicData: [
             {
               value: 3
             },
             {
               value: 2
             }
           ],
           rules: [
             {
               required: true,
               message: i18n.t('personCm.message.choseTypes'),
               trigger: 'change'
             }
           ]
         },
         {
           label: i18n.t('personCm.label.alarmType'),
           prop: 'hitType',
           span: 24,
           formslot: true,
           type: 'radio',
           dicData: [
             {
               value: 1
             },
             {
               value: 2
             }
           ],
           rules: [
             {
               required: true,
               message: i18n.t('personCm.message.alarmType'),
               trigger: 'change'
             }
           ]
         },
         {
           label: i18n.t('personCm.label.object'),
           prop: 'faceGroup',
           formslot: true,
           type: 'input',
           span: 24,
           rules: [
             {
               required: true,
               message: i18n.t('personCm.message.choseObject'),
               trigger: 'change'
             }
           ],
           clearable: true
         },
         {
           label: i18n.t('personCm.label.time'),
           prop: 'timeList',
           formslot: true,
           type: 'input',
           span: 24,
           rules: [
             {
               required: true,
               message: i18n.t('personCm.message.choseTime'),
               trigger: 'change'
             }
           ],
           clearable: true
         }
       ]
}